module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/07b6ebb8fb3209c04f0959e9c9da2df1.png";